import React from 'react';
import '../components/MainContent/App.css'; // Assuming you have a CSS file for styling the CGV page
const CGVPage: React.FC = () => {
  return (
    <main className=" cgv-page">
      <h1>Conditions Générales de Vente (CGV)</h1>

      <p>Les présentes conditions générales de vente régissent les relations contractuelles entre l'organisateur des balades et le client. En réservant une prestation, le client accepte sans réserve ces conditions.</p>

      <article className="card">
        <h2>Article 1 — Objet</h2>
        <p>Les présentes CGV décrivent les modalités de réservation, de paiement, d'annulation et d'exécution des prestations proposées (balades, séjours, services annexes).</p>
      </article>

      <article className="card">
        <h2>Article 2 — Prestations</h2>
        <p>Les prestations proposées sont décrites sur le site ou dans les documents contractuels remis au client. Les horaires, itinéraires et intervenants peuvent être modifiés pour des raisons de sécurité ou d'organisation.</p>
      </article>

      <article className="card">
        <h2>Article 3 — Réservation et Paiement</h2>
        <p>La réservation est effective après paiement des arrhes ou du montant total selon les modalités indiquées. Les moyens de paiement acceptés sont ceux précisés lors de la réservation.</p>
      </article>

      <article className="card">
        <h2>Article 4 — Annulation et Remboursement</h2>
        <p>En cas d'annulation par le client, des frais peuvent être appliqués selon le délai d'annulation. En cas d'annulation par l'organisateur (météo, force majeure), la prestation sera reprogrammée ou remboursée intégralement.</p>
      </article>

      <article className="card">
        <h2>Article 5 — Responsabilité</h2>
        <p>L'organisateur met en œuvre tous les moyens raisonnables pour assurer la sécurité des participants. La responsabilité ne pourra être engagée en cas d'accident dû à la faute du client ou à un cas de force majeure.</p>
      </article>

      <article className="card">
        <h2>Article 6 — Assurance</h2>
        <p>Le client est invité à souscrire une assurance individuelle couvrant les activités équestres si cela n'est pas déjà le cas. L'organisateur dispose d'une assurance responsabilité civile professionnelle.</p>
      </article>

      <article className="card">
        <h2>Article 7 — Bien-être animal</h2>
        <p>Le respect et le bien-être des chevaux sont au cœur de nos pratiques : rythme adapté, matériel entretenu et conditions de vie en troupeau. Toute négligence envers les animaux pourra entraîner l'exclusion de la prestation sans remboursement.</p>
      </article>
    <article className="card">
        <h2>Article 8 — Prix</h2>
        <p>Les prix sont indiqués en euros et peuvent être modifiés. Les prix applicables sont ceux en vigueur au moment de la réservation.</p>
      </article>
      
      <article className="card">
        <h2>Article 9 — Données personnelles</h2>
        <p>Les informations collectées sont nécessaires à la gestion des réservations et au respect des obligations réglementaires. Elles sont traitées conformément à la législation en vigueur et à notre politique de confidentialité.</p>
      </article>
<article className="card">
        <h2>Article 10 — Loi applicable et litiges</h2>
        <p>Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire.</p>
      </article>


      <section className="card">
        <h2>Contact</h2>
        <p>Pour toute question relative aux CGV, contactez-nous via le formulaire de contact ou par téléphone.</p>
      </section>
    </main>
  );
};

export default CGVPage;
